import React from 'react';
import MainBlog from '../components/MainBlog';

export default function MainBlogPage() {
  return (
    <div>
      <MainBlog/>
    </div>
  )
}
